import React from 'react';
import Chart1 from './Chart1';
import Chart2 from './Chart2';
import Chart3 from './Chart3';
import styles from './ChartCopyProfile.module.css'; // Import the CSS module


function ChartCopyProfile(props) {
    // Style object for the box shadow
    
    const boxShadowStyle = {
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
        padding: '20px',
        borderRadius: '10px',
        margin: '10px 0',
        background: props.isDarkMode ? "#000" : "#fff"
    };

    return (

        <div className={`${styles.first}`}>
            <div style={{ ...boxShadowStyle, width: "100%" }}>
                <Chart1 isDarkMode={props.isDarkMode}/>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
                <div style={{ ...boxShadowStyle, width: "50%" }}>
                    <Chart2 isDarkMode={props.isDarkMode}/>
                </div>
                <div style={{ ...boxShadowStyle, width: "50%", marginLeft: "1%" }}>
                    <Chart3 isDarkMode={props.isDarkMode}/>
                </div>
            </div>
        </div>
    )
}

export default ChartCopyProfile;

